/**
 * Route guards that gate global store behaviour by the active SPA route.
 *
 * Kept in their own module (no service-graph imports) so they are unit-testable
 * in isolation — the bug this guards against was a route rename (/patterns →
 * /journal) that silently disabled a re-render optimization because the only
 * check lived buried in store/index.tsx with no test.
 */

/**
 * True while the pattern-library page is active. That page is the one view that
 * does NOT read setups/account/regime from the store — it is fully react-query
 * driven (see usePatterns) — so while it is active we skip the scan/setup/kpi WS
 * dispatches entirely. Each such dispatch creates a new reducer state and
 * re-renders AppShell + the whole gallery (up to 96 cards) for data the page
 * never consumes.
 *
 * NB: this page shipped at /patterns and was later renamed to /journal. Match
 * both so a future rename of one path can't silently re-disable the skip.
 */
export function isPatternLibraryRouteActive(): boolean {
  if (typeof window === 'undefined') return false;
  const path = window.location.pathname;
  return path.startsWith('/journal') || path.startsWith('/patterns');
}
